export default __webpack_public_path__ + "static/media/rt.c04570a1.png";